import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/css/bootstrap.min.css';
import './styles/css/fontawesome.min.css';
import './styles/css/style.css';
import './styles/css/app.min.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';

 import { RouterProvider } from 'react-router-dom';
 import router from './routes';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <RouterProvider router={router} />
   {/* <App /> */}
  {/* </RouterProvider> */}
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
